<render-layout-slot
  class="slot-rolling-header"
  [layout]="layout"
  [slot]="'rolling-header'"
  #rollingHeader>
</render-layout-slot>
<render-layout-slot
  class="slot-header is-sticky"
  [layout]="layout"
  [slot]="'1'"
  #header>
</render-layout-slot>
<render-layout-slot
  class="slot-header-overlap is-sticky"
  [layout]="layout"
  [slot]="'2'"
  #headerOverlap>
</render-layout-slot>
<render-layout-slot
  [layout]="layout"
  [slot]="'3'">
</render-layout-slot>
<render-layout-slot
  class="slot-footer"
  [ngClass]="{'is-sticky': stickyFooter}"
  [layout]="layout"
  [slot]="'4'">
</render-layout-slot>
